import type { ComponentChildren } from "preact";

// Tiny CSS-only tooltip. The host element is wrapped in a span carrying a
// `data-edge` attribute that decides whether the bubble flies out to the left
// (when pill is docked right) or to the right (when pill is docked left).

export function Tooltip({
  text,
  edge,
  children,
}: {
  text: string;
  edge: "left" | "right";
  children: ComponentChildren;
}) {
  return (
    <span class="mf-tooltip-wrap" data-edge={edge}>
      {children}
      <span class="mf-tooltip" role="tooltip">
        {text}
      </span>
    </span>
  );
}
